import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import { Login } from "./pages/login";
import { lazy } from "solid-js";
import "./index.css";
import { protectedLoader } from "./auth.js";
import Layout from "./components/Layout";
import RoleGuard from "./components/RoleGuard";

const Dashboard = lazy(() => import("./pages/dashboard"));
const Tickets = lazy(() => import("./pages/tickets"));
const TicketDetail = lazy(() => import("./pages/ticket-detail"));
const Vendors = lazy(() => import("./pages/vendors"));
const VendorDetail = lazy(() => import("./pages/vendor-detail"));
const WorkOrders = lazy(() => import("./pages/work-orders"));
const WorkOrderDetail = lazy(() => import("./pages/work-order-detail"));
const EmployeePortal = lazy(() => import("./pages/employee-portal"));
const EmployeeAdmin = lazy(() => import("./pages/employee-admin"));
const Hr = lazy(() => import("./pages/hr"));
const Users = lazy(() => import("./pages/users"));
const Legal = lazy(() => import("./pages/legal"));

const wrapper = document.getElementById("root");

if (!wrapper) {
  throw new Error("Wrapper div not found");
}

render(() => (
  <Router root={Layout}>
    <Route path="/login" component={Login} />
    <Route path="/" component={Dashboard} preload={protectedLoader} />
    <Route path="/dashboard" component={Dashboard} preload={protectedLoader} />
    <Route path="/tickets" component={() => <RoleGuard requiredRole="tickets"><Tickets /></RoleGuard>} preload={protectedLoader} />
    <Route path="/tickets/:id" component={() => <RoleGuard requiredRole="tickets"><TicketDetail /></RoleGuard>} preload={protectedLoader} />
    <Route path="/vendors" component={() => <RoleGuard requiredRole="vendors"><Vendors /></RoleGuard>} preload={protectedLoader} />
    <Route path="/vendors/:id" component={() => <RoleGuard requiredRole="vendors"><VendorDetail /></RoleGuard>} preload={protectedLoader} />
    <Route path="/work-orders" component={() => <RoleGuard requiredRole="work_orders"><WorkOrders /></RoleGuard>} preload={protectedLoader} />
    <Route path="/work-orders/:id" component={() => <RoleGuard requiredRole="work_orders"><WorkOrderDetail /></RoleGuard>} preload={protectedLoader} />
    <Route path="/employee-portal" component={EmployeePortal} preload={protectedLoader} />
    <Route path="/employee-admin" component={() => <RoleGuard requiredRole="admin"><EmployeeAdmin /></RoleGuard>} preload={protectedLoader} />
    <Route path="/hr" component={Hr} preload={protectedLoader} />
    <Route path="/legal" component={() => <RoleGuard requiredRole="legal"><Legal /></RoleGuard>} preload={protectedLoader} />
    <Route path="/users" component={() => <RoleGuard requiredRole="admin"><Users /></RoleGuard>} preload={protectedLoader} />
  </Router>
), wrapper);
